import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@common/domain/common.model";
import api from "@common/services/api.service";
import AppConstants from "@utils/app.constants";
import { ProjectDepartmentModelRef } from "@views/project-plan/domain/project-plan.domain";
import {
  TaskRevisionApprovalPayload,
  TaskRevisionDTO,
  TaskRevisionInfo,
  TaskRevisionMinimal,
  TaskRevisionStoreState
} from "../utils/task-revision.domain";

export const createTaskRevision = createAsyncThunk<
  any,
  { payload:TaskRevisionDTO}
>("task_revision/create", async ({ payload}) => {
  const url = `${AppConstants.api}/task-revision`;
  const response = await api.post<ApplicationResponse<any>>(url, payload,{
    params:{
      RAR:0
    }
  });
  return;
});
export const latestRevisionTaskList = createAsyncThunk<
  any[],
  { projectId: string; type: string }
>("task_revision/latest/list", async ({ projectId, type }) => {
  const url = `${AppConstants.api}/revision/latest`;
    const response = await api.get<ApplicationResponse<any[]>>(url, {
      params: {
        id: projectId,
        type
      },
    });
    return response.data.data || [];
});
// export const createTaskRevision = createAsyncThunk<
//   any,
//   { payload: TaskRevisionDTO; isProjectRevisionOn: boolean; projectRevisionId: string }
// >("task_revision/create", async ({ payload, isProjectRevisionOn, projectRevisionId }) => {
//   const url = `${AppConstants.api}/task-revision`;

//   const response = await api.post<ApplicationResponse<any>>(url, payload, {
//     params: {
//       is_project_revision_on: isProjectRevisionOn,
//       project_revision_id: projectRevisionId,
//             RAR:0

//     },
//   });

//   return response.data;
// });

export const fetchTaskRevisionInfo = createAsyncThunk<
  TaskRevisionInfo,
  {taskId: string; revisionId?: string}
>("task_revision/fetch/revision-info", async ({ taskId,revisionId=null }) => {
  const baseUrl = `${AppConstants.api}/task-revision/${taskId}`;
  const config = {
    params: {
      revision_id: revisionId,
    }
  }
  const response = await api.get<ApplicationResponse<TaskRevisionInfo>>(baseUrl,config);

    return response.data.data ||  {} as TaskRevisionInfo;
});

export const fetchRevisionTaskList = createAsyncThunk<
  TaskRevisionMinimal[],
  { taskId:string }
>("task_revision/fetch/list", async ({ taskId }) => {
  const url = `${AppConstants.api}/task-revision`;
  const response = await api.get<ApplicationResponse<TaskRevisionMinimal[]>>(url, {
    params: {
      task_id: taskId,
    },
  });

  return response.data.data ||  [];
});




export const approveOrRejectTaskRevision = createAsyncThunk<
    void,
    TaskRevisionApprovalPayload
>("task_revision/fetch/list", async ({ ids,user_id,actions,remarks }) => {
  const payload = {
    ids,
    user_id,
    remarks
  };
  const url = `${AppConstants.api}/task-revision/${actions}`;
  const response = await api.put<ApplicationResponse<void>>(url,payload);
  return ;
});


const TaskRevisionSlice = createSlice({
  name: "task_revision",
  initialState: {
    minimal: { status: "loading", error: null, data: [] as TaskRevisionMinimal[] },
    taskRevisionInfo: { status: "loading", error: null, data: {} as TaskRevisionInfo  },

  } as TaskRevisionStoreState,
  reducers: {
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTaskRevisionInfo.pending, (state, action) => {
        state.taskRevisionInfo = {
          status: "loading",
          data: {} as TaskRevisionInfo,
          error: null,
        };
      })
      .addCase(fetchTaskRevisionInfo.fulfilled, (state, action) => {
        state.taskRevisionInfo = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchTaskRevisionInfo.rejected, (state, action) => {
        state.taskRevisionInfo = {
          status: "failed",
          data: {} as TaskRevisionInfo,
          error: null,
        };
      })
      .addCase(fetchRevisionTaskList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchRevisionTaskList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchRevisionTaskList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: null,
        };
      })
        .addCase(latestRevisionTaskList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
          .addCase(latestRevisionTaskList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
          .addCase(latestRevisionTaskList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: null,
        };
      });
  },
});

export default TaskRevisionSlice.reducer;
